var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerBody"},[_c('i',{staticClass:"bi bi-qr-code-scan",staticStyle:{"font-size":"120px"},on:{"click":_vm.scanQrCode}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("点击上图扫用户出示的核销二维码")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8d61d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/token_check.vue
// module id = null
// module chunks = 